import { Injectable } from '@angular/core';
import {
  CancelSubscription,
  CreateSubscriptionPayload,
  Subscription,
  UserSubscription,
} from '@core/models/entities/subscription.model';
import { environment } from '@environment';
import { HttpApi } from './http.api';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SubscriptionApi {
  private readonly baseUrl: string = environment.apiUrl;

  constructor(private httpApi: HttpApi) {}

  get(): Observable<UserSubscription[]> {
    return this.httpApi.get(`${this.baseUrl}/user-subscriptions`);
  }

  getCatalogSubscriptions(): Observable<Subscription[]> {
    return this.httpApi.get<Subscription[]>(`${this.baseUrl}/subscriptions`);
  }

  create(payload: CreateSubscriptionPayload): Observable<Subscription> {
    return this.httpApi.post(`${this.baseUrl}/user-subscriptions`, payload);
  }

  cancel(payload: CancelSubscription): Observable<UserSubscription> {
    return this.httpApi.post<UserSubscription>(`${this.baseUrl}/user-subscriptions/cancel/${payload.id}`, payload);
  }
}
